import React, { useState } from "react";

const DAY_PART_OPTIONS = [
  { value: "full", label: "весь день" },
  { value: "morning", label: "утро" },
  { value: "afternoon", label: "вечер" },
];

export default function UnpaidLeaveDialog({
  employeeName,
  initial,
  onSave,
  onDelete,
  onClose,
  error,
}) {
  const [start, setStart] = useState(initial?.start || "");
  const [end, setEnd] = useState(initial?.end || "");
  const [dayPart, setDayPart] = useState(initial?.day_part || "full");

  const isRange = Boolean(start && end && start !== end);
  const visibleOptions = isRange
    ? DAY_PART_OPTIONS.filter((option) => option.value === "full")
    : DAY_PART_OPTIONS;
  const effectiveDayPart = isRange ? "full" : dayPart;

  const handleStartChange = (value) => {
    setStart(value);
    if (end && value !== end) setDayPart("full");
  };

  const handleEndChange = (value) => {
    setEnd(value);
    if (start && value !== start) setDayPart("full");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    onSave({
      ...(initial?.id != null ? { id: initial.id } : {}),
      start,
      end,
      day_part: effectiveDayPart,
    });
  };

  return (
    <div className="users-modal-backdrop" onClick={onClose}>
      <div
        className="users-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="unpaid-leave-title"
        onClick={(event) => event.stopPropagation()}
      >
        <h3 id="unpaid-leave-title">Отгул — {employeeName}</h3>
        {error && (
          <div className="login-error" role="alert">
            {error}
          </div>
        )}
        <form className="users-form-grid" onSubmit={handleSubmit}>
          <label className="login-label">
            Начало
            <input
              className="login-input"
              type="date"
              value={start}
              onChange={(event) => handleStartChange(event.target.value)}
              required
            />
          </label>
          <label className="login-label">
            Конец
            <input
              className="login-input"
              type="date"
              value={end}
              onChange={(event) => handleEndChange(event.target.value)}
              required
            />
          </label>
          <label className="login-label">
            Часть дня
            <select
              className="login-input"
              value={effectiveDayPart}
              onChange={(event) => setDayPart(event.target.value)}
              disabled={isRange}
            >
              {visibleOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </label>
          <div className="users-form-actions">
            <button type="button" className="users-action-btn" onClick={onClose}>
              Отмена
            </button>
            {initial?.id != null && (
              <button type="button" className="users-action-btn" onClick={() => onDelete?.()}>
                Удалить
              </button>
            )}
            <button type="submit" className="users-action-btn">
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
